import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Navigator from 'Views/Onboarding/Components/Navigator';
import { useSurveyStepContext } from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepContext';
import SurveyFixedFooterActions from 'Views/Onboarding/Pages/Survey/SurveyFixedFooterActions';

const styles = () => ({
  root: {},
});

const SurveyStepFooter = ({
  className,
  classes,
  onSubmit,
  NextButtonProps,
  PreviousButtonProps,
  ...rest
}) => {
  const {
    onClickPrevious,
    hasNextStep,
    onClickNext,
    isSubmitting,
  } = useSurveyStepContext();

  return (
    <SurveyFixedFooterActions>
      <Navigator
        className={classNames(classes.root, className)}
        isLoading={isSubmitting}
        onNext={() => {
          return onClickNext(onSubmit);
        }}
        onPrevious={onClickPrevious}
        PreviousButtonProps={{
          ...PreviousButtonProps,
        }}
        NextButtonProps={{
          disabled: !hasNextStep || NextButtonProps.disabled,
          test: 'survey-navigator-next-button',
          ...NextButtonProps,
        }}
        {...rest}
      />
    </SurveyFixedFooterActions>
  );
};

SurveyStepFooter.defaultProps = {
  className: '',
  onSubmit: () => { },
  NextButtonProps: {},
  PreviousButtonProps: {},
};

SurveyStepFooter.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  PreviousButtonProps: PropTypes.object,
  NextButtonProps: PropTypes.object,
};

export default withStyles(styles)(SurveyStepFooter);
